import { Component, OnInit } from '@angular/core';

import { NgxPaginationModule } from 'ngx-pagination';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PartnerDto, RoleDto, UserDto } from '../api/models';
import * as bootstrap from 'bootstrap';
import { PartnerCtlService, UserControllerService } from '../api/services';
import { SessionService } from '../common/session.service';

@Component({
    selector: 'app-user',
    imports: [
    NgxPaginationModule,
    ReactiveFormsModule
],
    templateUrl: './user.component.html',
    styleUrl: './user.component.css'
})
export class UserComponent  implements OnInit{

  pageConfig= {
    itemsPerPage: 2,
    currentPage: 0,
    totalItems: 0
   };

  isAddUser:boolean=false;
  userForm:FormGroup;
  listUsers?:any;
  partners?:Array<PartnerDto>;
  connectedUser?:UserDto;
  roles?:Array<RoleDto>;
  message:string='';
  currentUser?:UserDto;
  formPartner:FormGroup;
  selectedPartner=0;

  constructor(private formBuilder:FormBuilder,
    private partnerService:PartnerCtlService,
    private session:SessionService,
    private userService:UserControllerService
  ){
    this.userForm = this.formBuilder.group({
      firstName :['', [Validators.required]],
      lastName :['', [Validators.required]],
      phone :['', [Validators.required]],
      id :[''],
      email :[''],
      idPartner:['', [Validators.required]],
      role:['', [Validators.required]],
    });
    this.formPartner= this.formBuilder.group({
      partner:['',Validators.required]
    });
    

  }
  ngOnInit(): void {
    
    this.connectedUser = this.session.getSessionInfo();
    this.loadPartners();
    this.selectedPartner=this.connectedUser?.partner?.id!!;
    this.getUsers(this.connectedUser?.partner?.id!!,this.pageConfig.itemsPerPage,0);
    this.getRoles();
  }
  onChangePartner(){
    let idPartner = this.formPartner.value.partner;
    this.selectedPartner=Number(idPartner);
    this.getUsers(this.selectedPartner,this.pageConfig.itemsPerPage,0);
  }

  loadPartners(){
     
    this.partnerService.getChildren1(
      this.connectedUser?.partner?.id!!,
      undefined,
      0,
      100

    ).subscribe({
      next:(resp)=>{
        let pp:Array<PartnerDto> = Array.of<PartnerDto>();
          pp.push(this.connectedUser?.partner!!);
           
        if(resp?.content){
          pp=pp.concat(resp?.content);
          
         }
         this.partners= pp;
      }
    })
  }
  getRoles(){
    let idPartner = this.userForm.value.idPartner;
    console.log(idPartner);
     if(idPartner){
      console.log('load role');
      let role = this.session.getSessionInfo().role;
    let connectedRole = role?.code?role.code:'';
    let partner =this.partners?.find(p=>p.id ==idPartner);
    this.userService.getRoles(
      connectedRole,
      partner?.type!!
    ).subscribe({
      next:(resp)=>{
        this.roles =resp; 
        if(this.roles?.length ==0){
          this.roles.push(this.connectedUser?.role!!);
        }
      },
      error:(err)=>{}
    });
     }else {
      console.log('can t load');
     }
  }

  onAddOrUpdateUser(){
    let form = this.userForm.value;

    let user:UserDto ={
      firstName:form.firstName,
      lastName:form.lastName,
      phone:form.phone,
      email:form.email,
      role: {
        code: form.role
      },
      partner: {
        id: form.idPartner,
        name:' ',
        phone:' ',
        address:' '
      }
    };
    if(form.id){
      user.id=form.id;
      this.updateUser(user);
    }else {
      this.addUser(user);
    }
  }
  getUsers(partner:number,pageSize:number,pageNumber:number){

    this.userService.getUsers(
      partner,
      pageNumber,
      pageSize
    ).subscribe
    ({
      next:(resp)=>{
        
        this.pageConfig.currentPage = resp.page?.number!!+1;
        this.pageConfig.totalItems = resp.page?.totalElements?resp.page.totalElements:0;
        this.pageConfig.itemsPerPage = resp.page?.size?resp.page?.size:20;
        this.listUsers=resp;
        console.log(this.pageConfig);
        this.isAddUser =false;
      }
    })

  }
  setUserDetails(user:UserDto){

    this.currentUser =user;
    this.userForm.controls['firstName'].setValue(user.firstName);
    this.userForm.controls['lastName'].setValue(user.lastName);
    this.userForm.controls['phone'].setValue(user.phone);
    this.userForm.controls['idPartner'].setValue(user.partner?.id);
    this.userForm.controls['email'].setValue(user.email);
    this.getRoles();
    this.userForm.controls['role'].setValue(user.role?.code);
    this.userForm.controls['id'].setValue(user.id);
    this.isAddUser = true;

  }
  onNextPage(event:number){
    this.getUsers(this.selectedPartner,this.pageConfig.itemsPerPage,event-1);
  }
  addUser(user:UserDto){
    console.log(this.userForm.value);
    
    
    this.userService.
    addUser(
     user
    )
    .subscribe({
      next:()=>{
        this.message ='utilisateur ajouté avec succés';
        this.userForm.reset();
        this.getUsers(user.partner?.id!!,20,0);
        this.isAddUser=false;
        
         const modAdd = new bootstrap.Modal('#modAddUser',{});
         modAdd.show();
      }
    });
  }
  updateUser(user:UserDto){
    console.log(this.userForm.value);
    
    this.userService.
    updateUser(
      user
    )
    .subscribe({
      next:()=>{
        this.message ='informations utilisateur modifié';
        this.userForm.reset();
        this.getUsers(user.partner?.id!!,20,0);
        this.isAddUser=false;
         const modAdd = new bootstrap.Modal('#modAddUser',{});
         modAdd.show();
      }
    });
  }

  changeScreen(){
    this.userForm.reset();
    this.isAddUser = !this.isAddUser;

    if(!this.isAddUser){
      this.getUsers(this.connectedUser?.partner?.id!!,20,0);
    }

  }
}
